var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"pt-5":"","pb-4":""}},[_c('highcharts',{attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }